import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Self-host da fonte Inter — substitui o <link> da Google Fonts por CSS
// minificado pelo Vite e fontes servidas do nosso domínio. Resolve:
//  - "Some CSS files don't seem to be minified" (Google Fonts CSS externa)
//  - Latência extra de DNS + fetch pra fonts.googleapis.com
//  - Privacidade: IP do usuário não vaza pro Google
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/inter/900.css";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
